import { useMemo } from 'react'

import { Alert } from '@/shared/ui/Alert'

import { useLevelContext } from '../../../context'

const messages = [
  'Boa, essa era a resposta certa!',
  'Parabéns, você acertou!',
  'Na mosca! Você está indo bem.',
  'Ótimo trabalho! Continue assim.',
  'Mandou bem! Resposta correta.',
  'Você acertou! Vamos para a próxima.',
  'Isso aí! Você está no caminho certo.',
  'Muito bom! Seu raciocínio está afiado.',
  'Resposta certa! Seu progresso é incrível.',
  'Acertou! Continue focado e avançando.'
]

export const DigitalProductJourneyLevelPlayChallengeFooterRightAnswerAlert = (
  props = {}
) => {
  const { answerIsRight } = useLevelContext()
  let message = useMemo(() => {
    return messages[Math.floor(Math.random() * messages.length)]
  }, [])
  let { challenge } = props
  let { save_answer: saveAnswer = false } = challenge.meta

  if (!answerIsRight) return null
  return (
    <div className="pointer-events-none absolute left-0 w-full bottom-0 rounded-b-xl px-6 pt-6 md:pt-8 md:px-8 pb-20">
      <Alert
        className="pointer-events-auto"
        variant="success"
        icon="circle-check"
        title={saveAnswer ? 'Resposta salva' : 'Resposta correta'}
        subtitle={saveAnswer ? undefined : message}
      />
    </div>
  )
}
